<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page">
        <div class="row-start row-space">
            <div class="form-item-char40">
                <label class="label-caption">Tipo</label>
                <select v-model="opcaoSelecionada">
                    <option v-for="opcao in lsOpcoes" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
                </select>
            </div>

            <div class="form-item-rangedata"><DateRangeSelect v-model="dateRange" /></div>
        </div>

        
        <div v-show="opcaoSelecionadaObj.ckFornecedor" class="row row-space">
            <div class="form-item">
                <FornecedorFrame v-model:objSelecionado="fornecedorSelecionado"/>
            </div>  
        </div>


        <div v-show="opcaoSelecionadaObj.ckPessoa" class="row row-space">
            <div class="form-item">
                <PessoaFrame v-model:objSelecionado="pessoaSelecionada"/>
            </div>  
        </div>


        <div class="row-start">
            <button type="button" @click="openReport">Imprimir</button>
            <button type="button" @click="closeForm">Retornar</button>
        </div>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validacoes } from '@/funcoes/validacoes';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import FornecedorFrame from '@/components/frames/FornecedorFrame.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import PessoaFrame from '@/components/frames/PessoaFrame.vue';

const emit = defineEmits(['close']);
const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const fornecedorSelecionado = ref(null);
const msgAlerta = ref(null);
const isLoading = ref(false);
const pessoaSelecionada = ref(null);
let informacoes;

const lsOpcoes = ref([
    {id: 'notas_stentidade', descricao: 'Entidades - Sintético',                    ckEntidade: false, ckFornecedor: false,  ckPessoa: false},
    {id: 'notas_anfornecedor', descricao: 'Fornecedor - Analítico',                 ckEntidade: false, ckFornecedor: true,   ckPessoa: false},
    {id: 'notas_anpessoa', descricao: 'Participante - Analítico',                   ckEntidade: false, ckFornecedor: false,  ckPessoa: true},
    {id: 'notas_stparticipante', descricao: 'Participante - Sintético por valor',   ckEntidade: false, ckFornecedor: false,  ckPessoa: false},
]);
const opcaoSelecionada = ref('notas_anpessoa');
const opcaoSelecionadaObj = computed(() =>
    lsOpcoes.value.find(o => o.id === opcaoSelecionada.value) || {}
);

function closeForm() {emit('close')}

async function openReport() {
    try{
        msgAlerta.value = null;
        Validacoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        isLoading.value = true;
        informacoes = `Período: ${Funcoes.formatDateFromJson(dateRange.value.startDate)} a ${Funcoes.formatDateFromJson(dateRange.value.endDate)}`;
        const dados = {
            nmrelatorio: opcaoSelecionada.value,
            idmunicipio: globalStore.idmunicipio,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate,
            idfornecedor: fornecedorSelecionado.value?.id,
            idpessoa: pessoaSelecionada.value?.id,
            informacoes: informacoes,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario};
        const response = await Api.genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}
</script>